define('sc_ext_carousel_slide.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('sc_ext_carousel_slide', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<li class=\"sc-ext-carousel-slide"
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":32},"end":{"line":1,"column":62}}})) != null ? stack1 : "")
    + "\"><div class=\"sc-ext-carousel-slide-content\" data-view=\"SlideContent.View\"></div></li> ";
},"1":function(container,depth0,helpers,partials,data) {
    return " active";
},"useData":true}, 'extensions/SuiteCommerce/Blog/2.1.1/', 'extensions/SuiteCommerce/Blog/2.1.1/', Handlebars);
});